import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FlashcardCard, GameAttemptResult, GameAttemptSubmission, LessonGamePlay } from 'src/app/models/module/lessongame.model';
import { ClassmanagementService } from 'src/app/services/classmanagement.service';
import { checkGameAttempt } from '../check-game-attempt';

@Component({
  selector: 'app-flashcard-game',
  templateUrl: './flashcard-game.component.html',
  styleUrls: ['./flashcard-game.component.css']
})
export class FlashcardGameComponent implements OnChanges {
  @Input() game: LessonGamePlay;
  @Output() attempted = new EventEmitter<GameAttemptResult>();

  cards: FlashcardCard[] = [];
  index = 0;
  flipped = false;
  confirmed = new Set<number>();
  submitting = false;
  result: GameAttemptResult = null;

  constructor(private classmanager: ClassmanagementService) { }

  ngOnChanges(): void {
    this.reset();
  }

  reset(): void {
    this.cards = this.game?.cards || [];
    this.index = 0;
    this.flipped = false;
    this.confirmed = new Set<number>();
    this.result = null;
  }

  get current(): FlashcardCard {
    return this.cards[this.index];
  }

  get isCurrentConfirmed(): boolean {
    return !!this.current && this.confirmed.has(this.current.id);
  }

  get allConfirmed(): boolean {
    return this.cards.length > 0 && this.cards.every(c => this.confirmed.has(c.id));
  }

  get confirmedCount(): number {
    return this.confirmed.size;
  }

  flip(): void {
    if (this.result) { return; }
    this.flipped = !this.flipped;
  }

  gotIt(): void {
    if (!this.flipped || this.result) { return; }
    this.confirmed.add(this.current.id);
    if (this.index < this.cards.length - 1) {
      this.index++;
      this.flipped = false;
    }
  }

  goTo(i: number): void {
    if (this.result) { return; }
    this.index = i;
    this.flipped = false;
  }

  next(): void {
    if (this.index < this.cards.length - 1) {
      this.index++;
      this.flipped = false;
    }
  }

  previous(): void {
    if (this.index > 0) {
      this.index--;
      this.flipped = false;
    }
  }

  finish(): void {
    if (!this.allConfirmed || this.submitting) { return; }
    this.submitting = true;
    const submission = new GameAttemptSubmission();
    submission.gameId = this.game.id;
    submission.confirmedCardIds = Array.from(this.confirmed);

    checkGameAttempt(this.game, submission, this.classmanager).subscribe(
      (result: GameAttemptResult) => {
        this.result = result;
        this.submitting = false;
        this.attempted.emit(result);
      },
      () => { this.submitting = false; }
    );
  }
}
